var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.999 511.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.862 423.724H8.828A8.829 8.829 0 0 1 0 414.896V97.104a8.829 8.829 0 0 1 8.828-8.828h203.034v335.448z",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.241 88.277l70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965h361.93a8.829 8.829 0 0 0 8.828-8.828V97.104a8.829 8.829 0 0 0-8.828-8.828h-361.93v.001z",
    fill: "#ff4b55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBh);
export default __webpack_public_path__ + "static/media/bh.e01e5d073cf82ecc1b133f182206795c.svg";
export { ForwardRef as ReactComponent };